export default {
  dialogContent: {
    termsOfUse: 'termsOfUse',
    privacy: 'privacy',
    invalidateProfileAlert: 'invalidateProfileAlert',
    sessionTimeout: 'sessionTimeout',
  },
};
